import comp from "./DowntimeAlert";
export default comp;
